const { get, reduce, isObject } = require('lodash');
const EnvHelper = require('../helpers/environment/EnvHelper');

const config = {
  gtmId: 'GTM-MVJJRWF',
  env: EnvHelper.getServiceEnv(),
  isBrowser: get(process, 'browser') || get(process, 'env.browser'),
  prod: process.env.NODE_ENV === 'production',
  adIndex: {
    contentPage: [4],
    projectPage: [4, 10],
  },
  totalCards: {
    contentPage: 5,
    projectPage: 10,
  },
  nextGenSupportedBrowsers: 'Chrome/| Firefox/| SamsungBrowser/| Edg/| Edge/',
  userAgentForMobile: 'Mobile',
  userAgentForTablet: 'iPad|tablet|Tablet',
};

const common = {
  local: {
    apiUrl: process.env.API_URL || 'http://local.thinkofliving.com:4000/api/',
    metaRobotContent: process.env.META_ROBOT_CONTENT || 'noindex, nofollow',
    metaRobotProject: process.env.META_ROBOT_PROJECT || 'noindex, nofollow',
    metaRobotSrp: process.env.META_ROBOT_SRP || 'noindex, nofollow',
    baseUrl: process.env.BASE_URL || 'http://local.thinkofliving.com/',
    loginUrl:
      process.env.LOGIN_URL ||
      'https://accounts.staging.thinkofliving.com/login?response_type=code&client_id=162o4t8kq19k88hqjr4nm1gekf&redirect_uri=https://local.thinkofliving.com:4000/api/user/auth',
    signupUrl:
      process.env.SIGNUP_URL ||
      'https://accounts.staging.thinkofliving.com/signup?response_type=code&client_id=162o4t8kq19k88hqjr4nm1gekf&redirect_uri=https://local.thinkofliving.com:4000/api/user/auth',
    updatePasswordUrl:
      process.env.LOGOUT_URL ||
      'https://accounts.staging.thinkofliving.com/update-password?client_id=162o4t8kq19k88hqjr4nm1gekf&state=relogin',
    logoutUrl:
      process.env.LOGOUT_URL ||
      'https://accounts.staging.thinkofliving.com/logout?client_id=162o4t8kq19k88hqjr4nm1gekf&logout_uri=https://local.thinkofliving.com:4000/api/user/logout',
    cookieDomain: process.env.COOKIE_DOMAIN || 'local.thinkofliving.com',
    reCaptchaSiteKey:
      process.env.RECAPTCHA_SITE_KEY ||
      '6LdT1yMbAAAAALRAvFMip9ogwICRH9Yzs7Jk3TTc',
    footerUrl:
      process.env.FOOTER_URL ||
      'https://header-footer-service.dev.core.iproperty.com.my/footer',
    privacyUrl:
      process.env.PRIVACY_URL ||
      'http://local.thinkofliving.com:3000/privacy-policy/',
    leadCaptureFormUrl:
      'http://local.thinkofliving.com:3000/events/listing-enquiry-form/',
    listing_enquiry_form: {
      form_id: 13433,
      name_field_id: 13086,
      phone_field_id: 12884,
      accept_terms_field_id: 13150,
    },
    seoMetaComposerUrl:
      process.env.SEO_META_COMPOSER_URL ||
      'https://seo-metacomposer-v2.integration.propertyguru.com/api/meta-tag-rules/interpolated',
    projectNetApiBaseUrl: process.env.PROJECTNET_API_BASE_URL || '',
    projectNetApiKey: process.env.PROJECTNET_API_KEY || '',
    ddListingsApiBaseUrl:
      process.env.DD_LISTINGS_API_BASE_URL ||
      'https://search-pgth.staging.propertyguru.com',
    previewAccessSecret: process.env.PREVIEW_ACCESS_SECRET || '',
  },
  staging: {
    apiUrl: EnvHelper.getApiURL(),
    metaRobotContent: process.env.META_ROBOT_CONTENT || 'noindex, nofollow',
    metaRobotProject: process.env.META_ROBOT_PROJECT || 'noindex, nofollow',
    metaRobotSrp: process.env.META_ROBOT_SRP || 'noindex, nofollow',
    baseUrl: process.env.BASE_URL || 'https://staging.thinkofliving.com/',
    loginUrl:
      process.env.LOGIN_URL ||
      'https://accounts.staging.thinkofliving.com/login?response_type=code&client_id=162o4t8kq19k88hqjr4nm1gekf&redirect_uri=https://staging.thinkofliving.com/api/user/auth&lang=th_TH',
    signupUrl:
      process.env.SIGNUP_URL ||
      'https://accounts.staging.thinkofliving.com/signup?response_type=code&client_id=162o4t8kq19k88hqjr4nm1gekf&redirect_uri=https://staging.thinkofliving.com/api/user/auth&lang=th_TH',
    updatePasswordUrl:
      process.env.LOGOUT_URL ||
      'https://accounts.staging.thinkofliving.com/update-password?client_id=162o4t8kq19k88hqjr4nm1gekf&state=relogin',
    logoutUrl:
      process.env.LOGOUT_URL ||
      'https://accounts.staging.thinkofliving.com/logout?client_id=162o4t8kq19k88hqjr4nm1gekf&logout_uri=https://staging.thinkofliving.com/api/user/logout',
    cookieDomain: process.env.COOKIE_DOMAIN || 'staging.thinkofliving.com',
    reCaptchaSiteKey:
      process.env.RECAPTCHA_SITE_KEY ||
      '6LdT1yMbAAAAALRAvFMip9ogwICRH9Yzs7Jk3TTc',
    footerUrl:
      process.env.FOOTER_URL ||
      'https://header-footer-service.stg.core.iproperty.com.my/footer',
    privacyUrl:
      process.env.PRIVACY_URL ||
      'https://staging.thinkofliving.com/privacy-policy/',
    leadCaptureFormUrl:
      'https://staging.thinkofliving.com/events/listing-enquiry-form/',
    listing_enquiry_form: {
      form_id: 13433,
      name_field_id: 13086,
      phone_field_id: 12884,
      accept_terms_field_id: 13150,
    },
    seoMetaComposerUrl:
      process.env.SEO_META_COMPOSER_URL ||
      'https://seo-metacomposer-v2.staging.propertyguru.com/api/meta-tag-rules/interpolated',
    projectNetApiBaseUrl: process.env.PROJECTNET_API_BASE_URL || '',
    projectNetApiKey: process.env.PROJECTNET_API_KEY || '',
    ddListingsApiBaseUrl:
      process.env.DD_LISTINGS_API_BASE_URL ||
      'https://search-pgth.staging.propertyguru.com',
    previewAccessSecret: process.env.PREVIEW_ACCESS_SECRET || '',
  },
  production: {
    apiUrl: EnvHelper.getApiURL(),
    metaRobotContent: process.env.META_ROBOT_CONTENT || 'index, follow',
    metaRobotProject: process.env.META_ROBOT_PROJECT || 'index, follow',
    metaRobotSrp: process.env.META_ROBOT_SRP || 'index, follow',
    baseUrl: process.env.BASE_URL || 'https://thinkofliving.com/',
    loginUrl:
      process.env.LOGIN_URL ||
      'https://accounts.thinkofliving.com/login?response_type=code&client_id=162o4t8kq19k88hqjr4nm1gekf&redirect_uri=https://thinkofliving.com/api/user/auth&lang=th_TH',
    signupUrl:
      process.env.SIGNUP_URL ||
      'https://accounts.thinkofliving.com/signup?response_type=code&client_id=162o4t8kq19k88hqjr4nm1gekf&redirect_uri=https://thinkofliving.com/api/user/auth&lang=th_TH',
    updatePasswordUrl:
      process.env.LOGOUT_URL ||
      'https://accounts.thinkofliving.com/update-password?client_id=162o4t8kq19k88hqjr4nm1gekf&state=relogin',
    logoutUrl:
      process.env.LOGOUT_URL ||
      'https://accounts.thinkofliving.com/logout?client_id=162o4t8kq19k88hqjr4nm1gekf&logout_uri=https://thinkofliving.com/api/user/logout',
    cookieDomain: process.env.COOKIE_DOMAIN || 'thinkofliving.com',
    reCaptchaSiteKey:
      process.env.RECAPTCHA_SITE_KEY ||
      '6LdT1yMbAAAAALRAvFMip9ogwICRH9Yzs7Jk3TTc',
    footerUrl:
      process.env.FOOTER_URL ||
      'https://header-footer-service.core.iproperty.com.my/footer',
    privacyUrl:
      process.env.PRIVACY_URL || 'https://thinkofliving.com/privacy-policy/',
    leadCaptureFormUrl:
      'https://thinkofliving.com/events/listing-enquiry-form/',
    listing_enquiry_form: {
      form_id: 50501,
      name_field_id: 24806,
      phone_field_id: 6650,
      accept_terms_field_id: 39470,
    },
    seoMetaComposerUrl:
      process.env.SEO_META_COMPOSER_URL ||
      'https://seo-metacomposer-v2.propertyguru.com/api/meta-tag-rules/interpolated',
    projectNetApiBaseUrl: process.env.PROJECTNET_API_BASE_URL || '',
    projectNetApiKey: process.env.PROJECTNET_API_KEY || '',
    ddListingsApiBaseUrl:
      process.env.DD_LISTINGS_API_BASE_URL ||
      'https://search-pgth.propertyguru.com',
    previewAccessSecret: process.env.PREVIEW_ACCESS_SECRET || '',
  },
  port: 3000,
  limitLoadMorePost: 6,
};

module.exports = {
  ...config,
  ...(common[EnvHelper.getServiceEnv()] || {}),
  ...reduce(
    common,
    (result, value, key) => {
      if (!isObject(value)) result[key] = value;
      return result;
    },
    {},
  ),
};
